import React, { ReactNode } from "react"

import { Text } from "ui-kit/components-branded/index"
import style from "modules/ClientAccount/components/ReferralLinkWidget/ReferralTemplate/style.module.scss"

interface Props {
    title: ReactNode
    details: ReactNode
}

export function ReferralTemplate(props: Props) {
    return (
        <div className={style.description}>
            <Text className={style.title}>{props.title}</Text>
            <Text className={style.subTitle}>{props.details}</Text>
        </div>
    )
}
